import * as Sentry from '@sentry/react'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import { RocketIcon } from '@phosphor-icons/react'
import { Spinner } from './components/ui/shadcn-io/spinner/index.tsx'
import { initAnalytics } from './lib/analytics.ts'
import { queryClient } from './lib/query.ts'
import reportWebVitals from './reportWebVitals.ts'
import './sentry.ts'
import './styles.css'

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    queryClient: queryClient,
  },
  scrollToTopSelectors: ['#main-scrollable-area'],
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPendingComponent: () => (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/30 z-50">
      <div className="flex flex-col items-center justify-center h-full">
        <RocketIcon size={80} weight="fill" className="text-blue-500" />
        <Spinner variant="ellipsis" className="text-blue-500" />
      </div>
    </div>
  ),
  defaultOnCatch: (error) => {
    // log to sentry
    Sentry.captureException(error)
    throw error
  },
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Initialize analytics
initAnalytics()

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
